import { fromJS } from 'immutable';
import { INIT_APP } from 'src/store/view/constants';
import { getViewInitialState } from 'src/store/view/reducer';

const initialState = fromJS(getViewInitialState());

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case INIT_APP:
      return state.set('app', payload.appName);

    default:
      return state;
  }
}
